module.exports = __webpack_public_path__ + "static/media/Alpha Makiwa.d2b7aa21.JPG";